/**
 * Hook to access SearchAndFilters context
 *
 * This hook provides access to the variant configuration shared across
 * SearchAndFilters sub-components via React Context.
 */

import { createContext, useContext } from 'react';
import type { SearchAndFiltersContextValue } from '../SearchAndFilters.types';

/**
 * Context for sharing variant configuration across sub-components
 */
export const SearchAndFiltersContext = createContext<SearchAndFiltersContextValue>({
  variant: 'default'
});

/**
 * Hook to access SearchAndFilters context
 * @returns The current SearchAndFilters context value
 */
export const useSearchAndFiltersContext = () => useContext(SearchAndFiltersContext);
